import { render, staticRenderFns } from "./ListVoucher.vue?vue&type=template&id=22c87065&"
import script from "./ListVoucher.vue?vue&type=script&lang=js&"
export * from "./ListVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports